import Customer from '@/customer/models/Customer';
import MediaFile from '@/general/models/MediaFile';
import MediaFileType from '@/shared/constants/MediaFileType';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import User from '@/shared/models/User';
import { decodeHtmlEntities } from '@/shared/utils/string';
import ChatMessage, { ChatJob } from '../models/ChatMessage';
import { ChatId } from '../models/ids';

const SCHEMA = {
  id: 'id',
  targets: (data: any) => data.sentTo?.split(',').map((s: string) => s.trim()).filter(Boolean) ?? [],
  content: (data: any) => (data.content ? decodeHtmlEntities(data.content) : null),
  media: parseChatMedia,
  job: (data: any) => parseChatJob(data),
  createdOn: (data: any) => parseMoment(data.createdOn),
  createdBy: (data: any) => {
    if (data.isToDealer) {
      return Customer.withData({ fullName: data.createdBy, avatar: data.avatar });
    } else {
      return User.withIdFullNameAndAvatar(data.outletUserId, data.createdBy, data.avatar);
    }
  },
};

const JOB_SCHEMA = {
  id: 'jobId',
  sequenceNumber: 'sequenceNr',
  description: 'jobDescription',
  status: 'status',
  statusBy: (data: any) => User.withFullName(data.statusBy),
};

function parseChatMedia(data: any): MediaFile | null {
  if (!data.moboMediaFile) return null;
  const media = new MediaFile();
  media.content = data.moboMediaFile;
  media.type = data.moboMediaFileType;
  media.thumbnail = data.moboMediaFileThumbnail;
  if (!media.thumbnail && media.type === MediaFileType.IMAGE) media.thumbnail = media.content;
  return media;
}

function parseChatJob(data: any): ChatJob | null {
  if (!data.contentJson) return null;
  const parsedData = JSON.parse(data.contentJson);
  return parseEntity(parsedData, JOB_SCHEMA, ChatJob);
}

export function parseChatMessage(data: any, chatId: ChatId): ChatMessage | null {
  const chatMessage = parseEntity(data, SCHEMA, ChatMessage);
  if (chatMessage) chatMessage.chatId = chatId;
  return chatMessage;
}

export function parseChatMessages(data: any, chatId: ChatId): Array<ChatMessage> {
  return parseEntities(data, d => parseChatMessage(d, chatId));
}
